import { render, staticRenderFns } from "./AIChatBox.vue?vue&type=template&id=812ae798&scoped=true"
import script from "./AIChatBox.vue?vue&type=script&lang=js"
export * from "./AIChatBox.vue?vue&type=script&lang=js"
import style0 from "./AIChatBox.vue?vue&type=style&index=0&id=812ae798&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+compiler-sfc@3.4.38_cache-loader@4.1.0_webpack@4.47.0__css-loader@3.6_lhktxyxuicyh6fb6yjjvusexfi/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "812ae798",
  null
  
)

export default component.exports